import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getSources = () => {
  try {
    return axios.get(BASE_URL + "feed/getSources", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFeed = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/getFeed", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const toggleThumb = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/toggleThumb", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getStats = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/getStats", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getRecentWindow = (offset, domains, filters) => {
  try {
    return axios.get(
      BASE_URL +
        "feed/getRecentWindow?offset=" +
        offset +
        "&domains=" +
        domains +
        "&filters=" +
        filters,
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getRecDocs = (offset) => {
  try {
    return axios.get(BASE_URL + "feed/getRecDocs?offset=" + offset, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getSavedItems = (offset) => {
  try {
    return axios.get(BASE_URL + "saved/getSavedItems?offset=" + offset, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAllSavedItemsExcel = () => {
  try {
    return axios.get(BASE_URL + "saved/getAllSavedItemsExcel", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateLike = (thumb, type, data) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateLike",
      { thumb, type, data },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateDislike = (thumb, type, data) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateDislike",
      { thumb, type, data },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateCatalog = (type, data) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateCatalog",
      { type, data },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

/* ─── Feed Views & Favorites ─── */

export const getFeedViews = () => {
  try {
    return axios.get(BASE_URL + "feed/getFeedViews", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const createFeedView = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/createFeedView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateFeedView = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/updateFeedView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const deleteFeedView = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/deleteFeedView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const favoriteFeedSource = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/favoriteFeedSource", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const unfavoriteFeedSource = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/unfavoriteFeedSource", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFeedViewStats = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/getFeedViewStats", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveFeedViewOrder = (payload) => {
  try {
    return axios.post(BASE_URL + "feed/saveFeedViewOrder", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
